import React from "react";
import { connect } from "react-redux";
import { rotateElement } from "../../../../actions";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import { bindActionCreators } from "redux";
import RotateIconRight from "../../../Layout/Icons/RotateIconRight";
import UndoIcon from "../../../Layout/Icons/UndoIcon";
import CheckmarkIcon from "../../../Layout/Icons/CheckmarkIcon";
import { countSelectedElements } from "../../../common/design";
import Dialog from "../../../Dialog";
import "./MobileToolControls.css";

class MobileToolControls extends React.Component {
  state = {
    showTip: false
  };

  // Handle rotation with our own buttons
  handleRotate = () => {
    const { layers } = this.props;
    const numSelectedElements = countSelectedElements(layers);

    // If no elements are selected, show the tip
    if (numSelectedElements === 0) {
      this.setState({ showTip: true });

      // Hide the tip after 3 seconds
      setTimeout(() => {
        this.setState({ showTip: false });
      }, 3000);

      return;
    }

    // If elements are selected, perform the rotation (right direction)
    this.props.rotateElement({ direction: "right" });
  };

  // Handle undo action
  handleUndo = () => {
    if (this.props.canUndo) {
      this.props.onUndo();
    }
  };

  // Handle toggle guides
  handleToggleGuides = () => {
    // Call the parent component's onToggleGuides function
    if (this.props.onToggleGuides) {
      this.props.onToggleGuides();
    }
  };

  handleHideDialog = () => {
    this.setState({ showTip: false });
  };

  render() {
    const { layers, guidesVisible } = this.props;
    const numSelectedElements = countSelectedElements(layers);
    const rotateDisabled = numSelectedElements === 0;
    const guidesSelected = guidesVisible ? "selected" : "";

    // Define the dialog configuration
    const dialog = {
      title: "Designer's Tip",
      message: "Select an element first to rotate it",
      topPosition: 0,
      leftPosition: 0,
      origin: "bottomleft"
    };

    return (
      <div className="mobile-tool-controls">
        {this.state.showTip && (
          <Dialog dialog={dialog} onHideDialog={this.handleHideDialog} />
        )}
        <div className="control__container">
          {/* Rotate Right Button */}
          <div className="control-button-wrapper">
            <button
              className="control__button button button--canvas button--rotate"
              onClick={this.handleRotate}
              disabled={rotateDisabled}
              aria-label="Rotate Right"
            >
              <RotateIconRight className="small-icon" />
            </button>
            <span className="mobile-button-label">Rotate</span>
          </div>

          {/* Show Guides Button */}
          <div className="control-button-wrapper">
            <button
              className={`control__button button button--canvas button--guides ${guidesSelected}`}
              onClick={this.handleToggleGuides}
              aria-label="Show Guides"
            >
              {guidesVisible ? <CheckmarkIcon className="small-icon" /> : null}
            </button>
            <span className="mobile-button-label">Guides</span>
          </div>

          {/* Undo Button */}
          <div className="control-button-wrapper">
            <button
              className="control__button button button--canvas button--undo"
              onClick={this.handleUndo}
              disabled={!this.props.canUndo}
              aria-label="Undo"
            >
              <UndoIcon className="small-icon" />
            </button>
            <span className="mobile-button-label">Undo</span>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const past = state.design.past || []; // Default to an empty array if undefined

  return {
    layers: state.design.present.layer_set,
    canUndo: past.length > 0
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      rotateElement,
      onUndo: UndoActionCreators.undo
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileToolControls);
